import { AppRouteProps } from "@bsm/component";
import SignatoryCreateContainer from "./container/SignatoryCreateContainer";

export const SignatoryCreateRoutes: Array<AppRouteProps> = [
    {
        path: "new",
        element: <SignatoryCreateContainer />,
    },
];